import { useContext, useMemo } from 'react';
import { AuthenticationContext } from '../../homeModules/auth/contexts/AuthenticationContext';

export const useCollectionsPermissions = () => {
  const { user } = useContext(AuthenticationContext);

  const hasCollectionsModule = useMemo(
    () => !!user?.modules?.some((m) => m.value === 'collections'),
    [user],
  );

  const isCollectionsAdmin = useMemo(
    () => !!user?.modules?.some((m) => m.value === 'collections' && parseInt(m.tier, 10) > 2),
    [user],
  );

  return { hasCollectionsModule, isCollectionsAdmin };
};
